import * as Yup from 'yup'
import { BaseEntity } from '../../../../shared/models/ApiModels'

export interface IPermission extends BaseEntity {
  id: string
  name: string
  description: string
  module: string
}

export interface IRoleModel extends BaseEntity { 
  roleName: string
  description: string
  permissions: string[]
  active: boolean
}

export const initialRole: IRoleModel = {
  id: '',
  roleName: '',
  description: '',
  permissions: [],
  active: true,
}

export const validationRole = Yup.object().shape({
  roleName: Yup.string().required('Rol adı zorunludur').min(2, 'En az 2 karakter olmalıdır'),
  description: Yup.string().required('Açıklama zorunludur'),
})

export const MODULE_LABELS: Record<string, string> = {
  CAR: 'Araç Yönetimi',
  CUSTOMER: 'Müşteri Yönetimi',
  RESERVATION: 'Rezervasyon',
  RENT: 'Kiralama',
  DEFINITION: 'Tanımlar',
  FINANCE: 'Finans',
  REPORT: 'Raporlar',
  ADMIN: 'Yönetim',
}
